import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import ContactModal from "../Modal";
const Section1 = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  const [formData, setFormData] = useState({
    firstName: "",

    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Handle input changes and clear errors
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  // Comprehensive form validation
  const validateForm = () => {
    const newErrors = {};

    // First name validation
    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
    } else if (formData.firstName.trim().length < 2) {
      newErrors.firstName = "First name must be at least 2 characters";
    }

    // Last name validation

    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = "Email address is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    // Phone validation
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\+?[\d\s\-\(\)]{8,}$/.test(formData.phone)) {
      newErrors.phone = "Please enter a valid phone number (minimum 8 digits)";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      // Show error notification with SweetAlert2
      Swal.fire({
        title: "Validation Error!",
        text: "Please fix the errors in the form before submitting.",
        icon: "error",
        confirmButtonColor: "#dc3545",
        confirmButtonText: "Fix Errors",
        background: "#fff",
        color: "#333",
      });
      return;
    }

    const payload = {
      ...formData,
      name: `${formData.firstName} `,
      ipaddress: "",
      number: formData.phone,
      pageUrl: window.location.href,
    };

    try {
      setIsSubmitting(true);

      const response = await fetch(
        "https://stagging-server786.com/send-mail/webinventix-ai/sendmail.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        // Reset form
        setFormData({
          firstName: "",

          email: "",
          phone: "",
          message: "",
        });
        setErrors({});

        // Show success message with SweetAlert2
        // await Swal.fire({
        //   title: "Success!",
        //   text: "Your request has been submitted successfully! Our specialist will contact you soon.",
        //   icon: "success",
        //   confirmButtonColor: "#28a745",
        //   confirmButtonText: "Continue",
        //   background: "#fff",
        //   color: "#333",
        //   timer: 3000,
        //   timerProgressBar: true,
        //   showClass: {
        //     popup: "animate__animated animate__zoomIn",
        //   },
        //   hideClass: {
        //     popup: "animate__animated animate__zoomOut",
        //   },
        // });

        // Navigate to thank you page
        // setTimeout(() => {
        //   window.location.href = "/professional-website-development/thankyou";
        // }, 500);
        navigate("/professional-website-development/thankyou");
      } else {
        throw new Error("Network response was not ok");
      }
    } catch (err) {
      console.error("Form submission error:", err);

      // Show error message with SweetAlert2
      Swal.fire({
        title: "Submission Failed!",
        text: "Something went wrong while submitting your request. Please try again or contact us directly.",
        icon: "error",
        confirmButtonColor: "#dc3545",
        confirmButtonText: "Try Again",
        showCancelButton: true,
        cancelButtonText: "Contact Support",
        cancelButtonColor: "#6c757d",
        background: "#fff",
        color: "#333",
      }).then((result) => {
        if (result.dismiss === Swal.DismissReason.cancel) {
          // User clicked "Contact Support" - you can add phone number or email here
          window.location.href = "tel:+16467607313";
        }
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  // Handle backdrop click to close modal

  return (
    <>
      <section className="banner">
        <div className="container">
          <div className="row">
            <div className="col-md-7 banner-text-main">
              <h1>
                Launch Your Custom <br />
                Website for Just
                <div style={{ display: "inline-flex" }}>
                  <span style={{ color: "#f5ca39" }}>&nbsp; $199</span>
                  {/* <span
                    style={{ color: "#FFF", fontSize: 20, fontWeight: 400 }}
                  >
                    <span
                      style={{ textDecoration: "line-through", color: "#FFF" }}
                    >
                      $398
                    </span>{" "}
                    <br />{" "}
                    <span style={{ color: "#f5ca39", textDecoration: "none" }}>
                      only
                    </span>
                  </span> */}
                </div>
              </h1>
              <h2>
                Create a professional website without breaking the bank.
                <br />
                For only $199, we’ll get your website up and running fast.{" "}
                <br />
                At Web Inventix, we’ve got everything you need to succeed
                online.
                <ul className="yel-list">
                  <li>
                    <img
                      src="professional-website-development/assets/images/yellow-tick.png"
                      alt="yellow tick"
                    />
                    <strong>Get Your Business Online:</strong>
                    <span
                      style={{
                        marginLeft: 4,
                        color: "#fff",
                        fontWeight: 400,
                        fontSize: 12,
                      }}
                    >
                      Show off what you do with a website that’s designed for
                      success
                    </span>
                  </li>
                  <li>
                    <img
                      src="professional-website-development/assets/images/yellow-tick.png"
                      alt="yellow tick"
                    />
                    <strong>Mobile-Friendly Design: </strong>
                    <span
                      style={{
                        marginLeft: 4,
                        color: "#fff",
                        fontWeight: 400,
                        fontSize: 12,
                      }}
                    >
                      Your website will look great on any device, anywhere.
                    </span>
                  </li>
                  <li style={{ lineHeight: "normal" ,display: 'flex' , alignItems: 'flex-start' }}>
                    <img
                      src="professional-website-development/assets/images/yellow-tick.png"
                      alt="yellow tick"
                      style={{paddingTop: 6}}
                    />
                    <div>
                      <strong>Grow Your Audience:</strong>
                      <span
                        style={{
                          marginLeft: 4,
                          color: "#fff",
                          fontWeight: 400,
                          fontSize: 12,
                        }}
                      >
                        {" "}
                        Expand your reach and attract more customers with a
                        website that works for you.
                      </span>
                    </div>
                  </li>
                  <li>
                    <img
                      src="professional-website-development/assets/images/yellow-tick.png"
                      alt="yellow tick"
                    />
                    <strong>Free Website Mockup:</strong>
                    <span
                      style={{
                        marginLeft: 4,
                        color: "#fff",
                        fontWeight: 400,
                        fontSize: 12,
                      }}
                    >
                      {" "}
                      Preview your site before it’s live, at no extra cost.
                    </span>
                  </li>
                </ul>
                <button
                  className="various grad-btn anchor"
                  name={149}
                  onClick={openModal}
                  style={{ color: "#000 !important" }}
                >
                  Schedule a Call Back
                </button>
                <a href="tel:+16467607313">
                  <span> Or call us at </span>(646) 760-7313
                </a>
                <img
                  src="professional-website-development/assets/images/rating.png"
                  alt="yellow tick"
                />
              </h2>
            </div>
            <div className="col-md-5 ">
              <div className="banner-form frm-brdr-grd">
                <form className="lead-form validate-banner-frm">
                  <h3>
                    Chat With Us to
                    <span>
                      <br />
                      Avail 50% Discount
                    </span>
                  </h3>
                  <div className="newlay">
                    <input
                      type="text"
                      name="firstName"
                      placeholder="Name *"
                      value={formData.firstName}
                      onChange={handleChange}
                      className={`required ${errors.firstName ? "error" : ""}`}
                    />
                    {errors.name && (
                      <small
                        className="error-message "
                        style={{
                          textAlign: "start",
                          color: "red",
                          display: "block",
                          marginTop: "-12px",
                          paddingLeft: "8px",
                        }}
                      >
                        {errors.name}
                      </small>
                    )}

                    <input
                      type="email"
                      name="email"
                      placeholder="Email Address *"
                      value={formData.email}
                      onChange={handleChange}
                      className={`required ${errors.email ? "error" : ""}`}
                    />
                    {errors.email && (
                      <small
                        className="error-message "
                        style={{
                          textAlign: "start",
                          color: "red",
                          display: "block",
                          marginTop: "-12px",
                          paddingLeft: "8px",
                        }}
                      >
                        {errors.email}
                      </small>
                    )}

                    <input
                      type="number"
                      name="phone"
                      placeholder="Phone No. *"
                      minLength={10}
                      value={formData.phone}
                      onChange={handleChange}
                      className={`required ${errors.phone ? "error" : ""}`}
                    />
                    {errors.phone && (
                      <small
                        className="error-message "
                        style={{
                          textAlign: "start",
                          color: "red",
                          display: "block",
                          marginTop: "-12px",
                          paddingLeft: "8px",
                        }}
                      >
                        {errors.phone}
                      </small>
                    )}

                    <textarea
                      name="message"
                      placeholder="To help us understand better, enter a brief description about your project."
                      value={formData.message}
                      style={{ resize: "none" }}
                      onChange={handleChange}
                      className={`required ${errors.message ? "error" : ""}`}
                    />

                    <input
                      type="button"
                      value={
                        isSubmitting ? "Submitting..." : "Get Started Now!"
                      }
                      disabled={isSubmitting}
                      onClick={handleSubmit}
                    />

                    {/* Hidden Inputs */}
                    <input
                      type="hidden"
                      name="msg"
                      value="Basic Website Package"
                    />
                    <input
                      type="hidden"
                      name="lead_area"
                      value="149"
                      className="leadprice"
                    />
                    <input type="hidden" name="lb_source" value="Organic" />
                    <input type="hidden" name="lead_type" value="website" />
                    <input type="hidden" name="lead_source" value="Organic" />
                    <input type="hidden" name="lead_source_category" value="" />
                    <input type="hidden" name="lead_source_offer" value="" />
                    <input type="hidden" name="lead_source_country" value="" />
                    <input type="hidden" name="utm_source" value="" />
                    <input type="hidden" name="utm_medium" value="" />
                    <input type="hidden" name="utm_term" value="" />
                    <input type="hidden" name="utm_content" value="" />
                    <input type="hidden" name="utm_campaign" value="" />
                    <input
                      type="hidden"
                      name="full_page_url"
                      value={window.location.href}
                    />
                    <input
                      type="hidden"
                      name="page_url"
                      value={window.location.href}
                    />
                    <input type="hidden" name="user_ip" value="" />
                    <input type="hidden" name="user_isp" value="" />
                    <input type="hidden" name="user_org" value="" />
                    <input type="hidden" name="user_country" value="" />
                    <input type="hidden" name="user_region" value="" />
                    <input type="hidden" name="user_city" value="" />
                    <input
                      type="hidden"
                      name="csrf_token"
                      value="00225d809f2da5960478cb261e570755"
                    />
                    <input
                      type="hidden"
                      name="package[]"
                      value="Website Design Tasks"
                    />
                    <input
                      type="hidden"
                      name="referer_url"
                      value="Banner Form"
                    />
                    <input
                      type="hidden"
                      name="pageurl"
                      value={window.location.href}
                    />

                    <p className="cta-form">
                      <a href="javascript:;" className="chat form-chat">
                        Talk To Our Design Consultant Now
                      </a>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ContactModal isOpen={showModal} onClose={closeModal} />
    </>
  );
};

export default Section1;
